import { gql } from "@apollo/client";

const SET_PM_AS_DEFAULT = gql`
  mutation SetPmAsDefault($input: SetStudentDefaultPaymentMethodInput!) {
    setStudentDefaultPaymentMethod(input: $input) {
      status
    }
  }
`;

export default SET_PM_AS_DEFAULT;
